import React, { FC } from 'react';
import { Box, Loader } from '@wix/design-system';
import css from './FullScreenLoader.scss';

interface FullScreenLoaderProps {
  label: string;
}

export const FullScreenLoader: FC<FullScreenLoaderProps> = ({ label }) => (
  <Box
    gap="SP2"
    align="center"
    direction="vertical"
    verticalAlign="middle"
    className={css.container}
  >
    <Loader text={label} />
  </Box>
);
